var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('header',{class:{ 'menu': _vm.isScrolled }},[_c('CNavMenu')],1)]),_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('CFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }